import { contentEditorsLoaded } from "./utils/contentEditorsLoaded"

$(document, '[data-content-name="booking_type"]').on("select2-selecting", function(e) { 
  const el = e.target.parentElement
  if (el && el.getAttribute('data-content-name') == 'booking_type') {
    toggleVisibilities(e.choice.id)
  }
})

contentEditorsLoaded(() => {
  const el = $("[data-content-name=booking_type]")
  if (el.length == 0) return

  const choice = el.find('option:selected').attr("value")
  toggleVisibilities(choice)
}) 


function toggleVisibilities(choice) {
  const reservation_names = ["seats", "seats_with_dinner", "show_payment_in_email"]
  const vivaticket_names = ["vivaticket_link"]

  toggleForChoice("reservation", choice, reservation_names)
  toggleForChoice("vivaticket", choice, vivaticket_names)
}

function toggleForChoice(toggleChoice, choice, names) {
  names.forEach(name => {
    const el = document.querySelector(`[data-content-name=${name}]`)

    if (toggleChoice == choice) {
      el.classList.remove('hidden')
    } else {
      el.classList.add('hidden')
    }
  })
}
